/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  BulkSmsHistoryItem,
  BulkSmsRecipientsResult,
  DeclinedAssignmentsResult,
  QualityGetBulkSmsHistoryParams,
  QualityGetDeclinedAssignmentsParams,
  SendBulkSmsRequest,
  SendBulkSmsResult,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useQualityGetDeclinedAssignmentsHook = () => {
  const qualityGetDeclinedAssignments =
    useCustomInstance<DeclinedAssignmentsResult>();

  return useCallback(
    (params?: QualityGetDeclinedAssignmentsParams, signal?: AbortSignal) => {
      return qualityGetDeclinedAssignments({
        url: `/api/Quality/GetDeclinedAssignments`,
        method: 'GET',
        params,
        signal,
      });
    },
    [qualityGetDeclinedAssignments]
  );
};

export const getQualityGetDeclinedAssignmentsQueryKey = (
  params?: QualityGetDeclinedAssignmentsParams
) => {
  return [
    `/api/Quality/GetDeclinedAssignments`,
    ...(params ? [params] : []),
  ] as const;
};

export const useQualityGetDeclinedAssignmentsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useQualityGetDeclinedAssignmentsHook>>
  >,
  TError = unknown,
>(
  params?: QualityGetDeclinedAssignmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useQualityGetDeclinedAssignmentsHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getQualityGetDeclinedAssignmentsQueryKey(params);

  const qualityGetDeclinedAssignments = useQualityGetDeclinedAssignmentsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useQualityGetDeclinedAssignmentsHook>>>
  > = ({ signal }) => qualityGetDeclinedAssignments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useQualityGetDeclinedAssignmentsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type QualityGetDeclinedAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useQualityGetDeclinedAssignmentsHook>>>
>;
export type QualityGetDeclinedAssignmentsQueryError = unknown;

export const useQualityGetDeclinedAssignments = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useQualityGetDeclinedAssignmentsHook>>
  >,
  TError = unknown,
>(
  params?: QualityGetDeclinedAssignmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useQualityGetDeclinedAssignmentsHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useQualityGetDeclinedAssignmentsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useQualityGetBulkSmsRecipientsHook = () => {
  const qualityGetBulkSmsRecipients =
    useCustomInstance<BulkSmsRecipientsResult>();

  return useCallback(
    (signal?: AbortSignal) => {
      return qualityGetBulkSmsRecipients({
        url: `/api/Quality/GetBulkSmsRecipients`,
        method: 'GET',
        signal,
      });
    },
    [qualityGetBulkSmsRecipients]
  );
};

export const getQualityGetBulkSmsRecipientsQueryKey = () => {
  return [`/api/Quality/GetBulkSmsRecipients`] as const;
};

export const useQualityGetBulkSmsRecipientsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useQualityGetBulkSmsRecipientsHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useQualityGetBulkSmsRecipientsHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getQualityGetBulkSmsRecipientsQueryKey();

  const qualityGetBulkSmsRecipients = useQualityGetBulkSmsRecipientsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useQualityGetBulkSmsRecipientsHook>>>
  > = ({ signal }) => qualityGetBulkSmsRecipients(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useQualityGetBulkSmsRecipientsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type QualityGetBulkSmsRecipientsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useQualityGetBulkSmsRecipientsHook>>>
>;
export type QualityGetBulkSmsRecipientsQueryError = unknown;

export const useQualityGetBulkSmsRecipients = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useQualityGetBulkSmsRecipientsHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useQualityGetBulkSmsRecipientsHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useQualityGetBulkSmsRecipientsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useQualitySendBulkSmsHook = () => {
  const qualitySendBulkSms = useCustomInstance<SendBulkSmsResult>();

  return useCallback(
    (sendBulkSmsRequest: SendBulkSmsRequest) => {
      return qualitySendBulkSms({
        url: `/api/Quality/SendBulkSms`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: sendBulkSmsRequest,
      });
    },
    [qualitySendBulkSms]
  );
};

export const useQualitySendBulkSmsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useQualitySendBulkSmsHook>>>,
    TError,
    { data: SendBulkSmsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useQualitySendBulkSmsHook>>>,
  TError,
  { data: SendBulkSmsRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const qualitySendBulkSms = useQualitySendBulkSmsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useQualitySendBulkSmsHook>>>,
    { data: SendBulkSmsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return qualitySendBulkSms(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type QualitySendBulkSmsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useQualitySendBulkSmsHook>>>
>;
export type QualitySendBulkSmsMutationBody = SendBulkSmsRequest;
export type QualitySendBulkSmsMutationError = unknown;

export const useQualitySendBulkSms = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useQualitySendBulkSmsHook>>>,
    TError,
    { data: SendBulkSmsRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useQualitySendBulkSmsHook>>>,
  TError,
  { data: SendBulkSmsRequest },
  TContext
> => {
  const mutationOptions = useQualitySendBulkSmsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useQualityGetBulkSmsHistoryHook = () => {
  const qualityGetBulkSmsHistory = useCustomInstance<BulkSmsHistoryItem[]>();

  return useCallback(
    (params?: QualityGetBulkSmsHistoryParams, signal?: AbortSignal) => {
      return qualityGetBulkSmsHistory({
        url: `/api/Quality/GetBulkSmsHistory`,
        method: 'GET',
        params,
        signal,
      });
    },
    [qualityGetBulkSmsHistory]
  );
};

export const getQualityGetBulkSmsHistoryQueryKey = (
  params?: QualityGetBulkSmsHistoryParams
) => {
  return [
    `/api/Quality/GetBulkSmsHistory`,
    ...(params ? [params] : []),
  ] as const;
};

export const useQualityGetBulkSmsHistoryQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useQualityGetBulkSmsHistoryHook>>
  >,
  TError = unknown,
>(
  params?: QualityGetBulkSmsHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useQualityGetBulkSmsHistoryHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getQualityGetBulkSmsHistoryQueryKey(params);

  const qualityGetBulkSmsHistory = useQualityGetBulkSmsHistoryHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useQualityGetBulkSmsHistoryHook>>>
  > = ({ signal }) => qualityGetBulkSmsHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useQualityGetBulkSmsHistoryHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type QualityGetBulkSmsHistoryQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useQualityGetBulkSmsHistoryHook>>>
>;
export type QualityGetBulkSmsHistoryQueryError = unknown;

export const useQualityGetBulkSmsHistory = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useQualityGetBulkSmsHistoryHook>>
  >,
  TError = unknown,
>(
  params?: QualityGetBulkSmsHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useQualityGetBulkSmsHistoryHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useQualityGetBulkSmsHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
